export { AccessPointsUtil, hasEveryAccessPointUuid }
export type { AccessPointLevel, AccessPointUuids }

const GRADE_LEVEL = 'grade_level'
const APPROACHING = 'approaching'
const DEVELOPING = 'developing'

type AccessPointLevel = typeof GRADE_LEVEL | typeof APPROACHING | typeof DEVELOPING
type AccessPointUuids = Partial<Record<AccessPointLevel, string>>

interface StringKeyValues {
  [key: string]: string;
}

const AccessPointLabelsMap: StringKeyValues = Object.freeze({
  [GRADE_LEVEL]: 'Grade Level',
  [APPROACHING]: 'Approaching',
  [DEVELOPING]: 'Developing'
})

const AccessPointValues = Object.freeze({
  GRADE_LEVEL,
  APPROACHING,
  DEVELOPING
})
const AccessPointValuesList: AccessPointLevel[] = [GRADE_LEVEL, APPROACHING, DEVELOPING]

const AccessPointsUtil = {
  valuesMap: AccessPointValues,
  orderedValues: AccessPointValuesList,
  labelsMap: AccessPointLabelsMap
}

function hasEveryAccessPointUuid(uuids: AccessPointUuids | undefined): uuids is Record<AccessPointLevel, string> {
  if (!uuids) return false
  return AccessPointValuesList.every((level) => Boolean(uuids[level]))
}
